<template>
  <v-card color="transparent" v-if="loading" class="w-[450px] !rounded-3xl relative">
    <v-skeleton-loader type="image,article" height="100%" class=" skeleton">
    </v-skeleton-loader>
  </v-card>


  <v-card v-else-if="video" :class="`animate__animated ${data}`" elevation="5" id="preview"
    class="w-[450px] !rounded-3xl " dark>
    <video autoplay loop muted :src="video" class="!object-cover !max-h-full !rounded-3xl" height="100%" width="100%">
    </video>
    <div class="bg-gradient-to-t from-black to-transparent h-full w-full absolute top-0 !rounded-3xl"></div>
    <div class="drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] capitalize absolute md:bottom-10 bottom-7 md:px-5 px-4" v-motion
      :initial="{ opacity: 0, y: 100 }" :enter="{
        opacity: 1, y: 0, transition: {
          duration: 400,
          type: 'keyframes',
          ease: 'backInOut',
          delay: 300,
        },
      }">
      <h3 class="text-lg font-bold font-Nunito flex items-center">
        {{ name }}
      </h3>
      <h3 class="text-sm font-Nunito capitalize">
        {{ `${age}y, ${subtitle}` }}
      </h3>
      <h3 class="text-sm font-Nunito max-h-[3.75rem] overflow-hidden">
        {{ description }}
      </h3>
    </div>

    <!-- <v-img gradient="to bottom , transparent , black" height="100%" width="100%" :lazy-src="img" :src="img">

    </v-img> -->
  </v-card>
  <v-card v-else :class="`animate__animated ${data}`" elevation="5" id="preview" class="w-[450px] !rounded-3xl " dark>

    <v-img gradient="to bottom , transparent , black" height="100%" width="100%" :lazy-src="img" :src="img">
      <!-- <div class="bg-gradient-to-t from-black to-transparent h-full w-full absolute top-0 !rounded-3xl"></div> -->

      <div class="drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] capitalize absolute md:bottom-10 bottom-7 md:px-5 px-4">
        <h3 class="text-lg font-bold font-Nunito flex items-center" v-motion :initial="{ opacity: 0, y: 100 }" :enter="{
          opacity: 1, y: 0, transition: {
            duration: 400,
            type: 'keyframes',
            ease: 'easeInOut',
            delay: 300,

          },
        }">
          {{ name }}
        </h3>
        <h3 class="text-sm font-Nunito capitalize" v-motion :initial="{ opacity: 0, y: 100 }" :enter="{
          opacity: 1, y: 0, transition: {
            duration: 400,
            type: 'keyframes',
            ease: 'easeInOut',
            delay: 400,

          },
        }">
          {{ `${age}y, ${subtitle}` }}
        </h3>
        <h3 class="text-sm font-Nunito max-h-[3.75rem] overflow-hidden" v-motion :initial="{ opacity: 0, y: 100 }" :enter="{
          opacity: 1, y: 0, transition: {
            duration: 400,
            type: 'keyframes',
            ease: 'easeInOut',
            delay: 500,

          },
        }">
          {{ description }}
        </h3>
      </div>
    </v-img>
  </v-card>
</template>
<script>
import { Icon } from '@iconify/vue2';


export default {
  props: {
    name: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    description: {
      type: String,
    },
    img: {
      type: String,
    },
    video: {
      type: String,
    },
    age: {
      type: String,
    },
    data: {
      type: String,
    },
    loading: {
      type: Boolean,
    }
  },
  data() {
    return {
      toggler: false,
      test: false,
    };
  },
  methods: {
    toggle() {
      this.toggler = !this.toggler;
      var data = this.toggler;
      this.$emit("openLightBox", data);
    },
  },
  components: { Icon }
};
</script>
<style scoped>
/* @media (min-width: 1400px) and (max-width: 1600px) {
  #preview {
    width: 85% !important;
  }
}

@media (min-width: 1200px) and (max-width: 1400px) {
  #preview {
    width: 90% !important;
  }
}

@media (min-width: 1200px) and (max-width: 1266px) {
  #preview {
    width: 70% !important;
  }
}

@media (min-width: 1080px) and (max-width: 1200px) {
  #preview {
    width: 80% !important;
  }
}

@media (min-width: 750px) and (max-width: 1080px) {
  #preview {
    width: 85% !important;
  }
}

@media (min-width: 600px) and (max-width: 750px) {
  #preview {
    width: 65% !important;
  }
} */

.skeleton:deep(.v-skeleton-loader__image) {
  width: 100% !important;
  height: 100% !important;
  z-index: 1;
}

.skeleton:deep(.v-skeleton-loader__article) {
  position: absolute;
  z-index: 5;
  width: 100% !important;
  bottom: 40px;
  border-radius: 0px !important;
  background: transparent !important;
}
</style>
